import { Button, Group, Select, Stack, Text } from '@mantine/core';
import HelpPopover from '../../HelpPopover/HelpPopover';
import PlaceholderInput from './PlaceholderInput';
import { HELP } from './workspaceHelp';

const METHODS = ['GET', 'POST'];

const TryChips = ({ scenarios, onTry }) => {
  if (!scenarios.length) return null;
  const plain = scenarios.filter((scenario) => !scenario.group);
  const options = scenarios.filter((scenario) => scenario.group);
  const chip = (scenario) => (
    <Button key={scenario.id} size="compact-xs" variant="default" radius="xl" onClick={() => onTry(scenario)}>
      {scenario.label}
    </Button>
  );

  return (
    <Group gap={6}>
      <Text size="xs" c="dimmed">
        Try:
      </Text>
      {plain.map(chip)}
      {options.length > 0 && (
        <Text size="xs" c="dimmed">
          Each option:
        </Text>
      )}
      {options.map(chip)}
    </Group>
  );
};

// Method, URL, Examples and Send on one row, above both panes, with the Try chips under Send;
// Send stays usable on a live tool.
const RequestBar = ({
  form,
  setField,
  argNames,
  testValues,
  error,
  readOnly,
  onUseExample,
  onSend,
  sending,
  scenarios = [],
  onTry,
}) => (
  <Stack gap={6} p="sm">
    <Group gap="xs" align="flex-start" wrap="nowrap">
      <Select
        aria-label="Method"
        w={96}
        size="xs"
        data={METHODS}
        allowDeselect={false}
        disabled={readOnly}
        value={form.method}
        onChange={(value) => {
          setField('method', value || 'GET');
          // The body is only sent with POST, so one left behind under GET would be dropped unseen.
          if (value === 'GET') setField('body', '');
        }}
      />
      <PlaceholderInput
        aria-label="URL"
        size="xs"
        placeholder="https://api.example.com/availability?city={{args.city}}"
        error={error}
        readOnly={readOnly}
        value={form.url}
        onChange={(value) => setField('url', value)}
        argNames={argNames}
        testValues={testValues}
      />
      <HelpPopover {...HELP.url} triggerLabel="Examples ▾" onUse={readOnly ? undefined : onUseExample} />
      <Button size="xs" loading={sending} onClick={onSend}>
        Send
      </Button>
    </Group>
    <Group justify="flex-end">
      <TryChips scenarios={scenarios} onTry={onTry} />
    </Group>
  </Stack>
);

export default RequestBar;
